var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCertification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-273.000000, -629.000000)",
    stroke: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(274.000000, 630.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "6.28047469 19 18 21.4810666 11.7195253 40 6.80183386 35.9816267 4.99600361e-16 37.5189334"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    transform: "translate(21.000000, 29.500000) scale(-1, 1) translate(-21.000000, -29.500000) ",
    points: "18.2804747 19 30 21.4810666 23.7195253 40 18.8018339 35.9816267 12 37.5189334"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Star",
    fill: "#FFFFFF",
    points: "15 27.7835519 12.653483 29.8153251 11.0496652 27.1578803 8.1901425 28.3650979 7.48601672 25.3421107 4.39339828 25.6066017 4.65788927 22.5139833 1.63490214 21.8098575 2.84211967 18.9503348 0.184674891 17.346517 2.2164481 15 0.184674891 12.653483 2.84211967 11.0496652 1.63490214 8.1901425 4.65788927 7.48601672 4.39339828 4.39339828 7.48601672 4.65788927 8.1901425 1.63490214 11.0496652 2.84211967 12.653483 0.184674891 15 2.2164481 17.346517 0.184674891 18.9503348 2.84211967 21.8098575 1.63490214 22.5139833 4.65788927 25.6066017 4.39339828 25.3421107 7.48601672 28.3650979 8.1901425 27.1578803 11.0496652 29.8153251 12.653483 27.7835519 15 29.8153251 17.346517 27.1578803 18.9503348 28.3650979 21.8098575 25.3421107 22.5139833 25.6066017 25.6066017 22.5139833 25.3421107 21.8098575 28.3650979 18.9503348 27.1578803 17.346517 29.8153251"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 7.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCertification);
export default __webpack_public_path__ + "static/media/icon-certification.b089643aeef2b5ee710f7c6aae37e40f.svg";
export { ForwardRef as ReactComponent };